<mat-toolbar class="toolbar top">
  <span class="main-heading-text">{{ title() }}</span>
  <img class="pointer" src="assets/project-icons/x.svg" alt="X" (click)="close.emit()" />
</mat-toolbar>

<div class="map-editor-container">
  <div class="controls" *transloco="let t">
    <app-collapsable-section [title]="t('pathways') + ' (' + getPathwaysAsFormGroups().length + ')'">
      <div class="pathways-section">
        <div class="display-flex-centered gap-8"></div>
        <button class="secondary-bar-btn add-buttons"
                (click)="addPathway()">
          <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
            <use xlink:href="assets/project-icons/add.svg#a"></use>
          </svg>
          {{t('addPathway')}}
        </button>
        <button class="secondary-bar-btn add-buttons"
                (click)="importFromGPX()">
          <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
            <use xlink:href="assets/project-icons/add.svg#a"></use>
          </svg>
          {{t('importFromGPX')}}
        </button>

        @for (pathway of getPathwaysAsFormGroups(); track pathway.value.uuid) {
          <div class="pathway-controls" [formGroup]="pathway">
            <mat-form-field appearance="fill" class="form-field" color="accent">
              <mat-label>{{t('pathwayName')}}</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
            <div class="bottom-controls">
              <input
                class="color-selector-button"
                [style.background]="pathway.value.color"
                [cpPresetColors]="['#2bce07', '#f8d00c', '#2889e9', '#f10303']"
                [(colorPicker)]="pathway.value.color"
                (colorPickerChange)="pathway.patchValue({color: $event})"
              />
              <div class="map-to-roads-controls-container">
                <button class="secondary-bar-btn"
                        [ngClass]="{active: pathway.value.mappedToRoads}"
                        (click)="mapToRoadsToggle(pathway)"
                        [disabled]="currentPathway?.value.uuid !== pathway.value.uuid || (pathwaysEditEngines.get(pathway.value.uuid)?.orderedVertices?.length || 0) < 3">
                  {{t('mapToRoads')}}
                </button>
                :

                <button class="image-btn borderless"
                        [ngClass]="{active: pathway.value.mappedPathProfile === 'walking'}"
                        (click)="changePathwayMappingProfile(pathway, 'walking')"
                        [disabled]="!pathway.value.mappedToRoads">
                  <q-svg-wrapper iconPath="project-icons/walking-32" width="24" height="24" viewBox="0 0 32 32"></q-svg-wrapper>
                </button>
                <button class="image-btn borderless"
                        [ngClass]="{active: pathway.value.mappedPathProfile === 'cycling'}"
                        (click)="changePathwayMappingProfile(pathway, 'cycling')"
                        [disabled]="!pathway.value.mappedToRoads">
                  <q-svg-wrapper iconPath="project-icons/cycling-32" width="24" height="24" viewBox="0 0 32 32"></q-svg-wrapper>
                </button>
                <button class="image-btn borderless"
                        [ngClass]="{active: pathway.value.mappedPathProfile === 'driving'}"
                        (click)="changePathwayMappingProfile(pathway, 'driving')"
                        [disabled]="!pathway.value.mappedToRoads">
                  <q-svg-wrapper iconPath="project-icons/car-32" width="24" height="24" viewBox="0 0 32 32"></q-svg-wrapper>
                </button>
              </div>
              <div class="display-flex-centered" style="gap: 4px">
                <div class="image-btn">
                  <q-svg-wrapper iconPath="project-icons/x" (click)="removePathway(pathway)"></q-svg-wrapper>
                </div>
                <div class="image-btn" [ngClass]="{active: currentPathway?.value.uuid === pathway.value.uuid}">
                  <q-svg-wrapper iconPath="project-icons/pencil" (click)="startEditPathway(pathway)"></q-svg-wrapper>
                </div>
                <div class="image-btn">
                  <q-svg-wrapper iconPath="project-icons/share" (click)="exportPathway(pathway)"></q-svg-wrapper>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </app-collapsable-section>
    <app-collapsable-section [title]="t('comments') + ' (' + getCommentsAsFormGroups().length + ')'">
      <div class="comments-section">
        <button class="secondary-bar-btn add-buttons"
                (click)="addComment()">
          <svg class="smaller-img-size" viewBox="0 0 24 24" width="18" height="18">
            <use xlink:href="assets/project-icons/add.svg#a"></use>
          </svg>
          {{t('addComment')}}
        </button>
        @if (commentsShown) {
          <button class="warning-bar-btn add-buttons" (click)="hideComments()">
            {{t('hideComments')}}
          </button>
        } @else {
          <button class="primary-bar-btn add-buttons" (click)="showComments()">
            {{t('showComments')}}
          </button>
        }

        @for (comment of getCommentsAsFormGroups(); track comment.value.uuid) {
          <lib-comment-section-editor
            [commentFormGroup]="comment"
            [editEngine]="commentsEditEngines.get(comment.value.uuid)"
            (deleteSelf)="removeComment(comment);"
          ></lib-comment-section-editor>
        }
      </div>
    </app-collapsable-section>
  </div>

  <div id="map-container" class="map">
    @if ((mapControlVisibility$ | async)?.state === 'show') {
      <div class="map-controls">
        @if ((mapControlVisibility$ | async)?.showConfirm) {
          <div class="map-control-slot pointer" (click)="mapControlPanelActions$.next({ button: 'confirm' })">
            <svg class="regular-img-size color-green">
              <use xlink:href="assets/project-icons/check.svg#c"></use>
            </svg>
          </div>
        }
      </div>
    }

    <button class="map-btn" style="top: 156px" (click)="goToMyLocation()">
      <svg class="pointer" viewBox="0 0 24 24" width="20" height="20">
        <use xlink:href="assets/map-icons/location.svg#c"></use>
      </svg>
    </button>

    <button class="map-btn" style="top: 200px" (click)="toggleMagStyle()">
      <svg class="pointer" viewBox="0 0 24 24" width="20" height="20">
        <use xlink:href="assets/map-icons/layers.svg#c"></use>
      </svg>
    </button>
  </div>
</div>

<mat-toolbar class="toolbar bottom element-shadow">
  <span class="filler"></span>
  <button class="primary-bar-btn" (click)="applyClick.emit(apply())" [disabled]="!isValid()">
    <svg class="regular-img-size">
      <use xlink:href="assets/project-icons/check.svg#c"></use>
    </svg>
    {{'apply' | transloco}}
  </button>
</mat-toolbar>
